import * as React from "react"
import { ResponsiveModalLayout } from "./ResponsiveModalLayout"

interface ResponsiveModalProps {
  children: React.ReactNode
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string
  className?: string
  /** When false, prevents the mobile Drawer from being closed by swipe/drag gesture (useful for heavy editor modals). */
  dismissible?: boolean
  stickyHeader?: boolean
}

export function ResponsiveModal({
  children,
  open,
  onOpenChange,
  title,
  description,
  className,
  stickyHeader,
  dismissible = true,
}: ResponsiveModalProps) {
  return (
    <ResponsiveModalLayout
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      className={className}
      stickyHeader={stickyHeader}
      dismissible={dismissible}
    >
      {children}
    </ResponsiveModalLayout>
  )
}
